import React from "react";
import ReactMarkdown, {Components} from "react-markdown";
import {calcTimeDiff} from "../../chatbotUtil";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {ChatMessage} from "../../chatbotSlice";
import {BotTextMessage} from "./BotTextMessage";

const convertToEmbedURL = (url: string) => {
    if (url.startsWith("https://youtu.be/")) {
        const videoID = url.split("youtu.be/")[1];
        return `https://www.youtube.com/embed/${videoID}`;
    }
    if (url.startsWith("https://www.youtube.com/watch?v=")) {
        const videoID = url.split("www.youtube.com/watch?v=")[1];
        return `https://www.youtube.com/embed/${videoID}`;
    }
    return url;
}

const components = {
    // @ts-ignore
    a: ({href, children}) => {
        return (
            <a
                href={href}
                target="_blank"
                style={{textDecoration: "underline"}}
            >
                {children}
            </a>
        );
    },
} as Components;

interface BotVideoMessageProps {
    index: number
    message: ChatMessage
}

export const BotVideoMessage: React.FC<BotVideoMessageProps> = ({
                                                                    index,
                                                                    message
                                                                }) => {
    if (message.message.videoLink) {
        return (
            <div key={index} className="mt-4 relative self-start w-full">
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col w-[85%]">
                        <div className="rounded-xl border-[1px] text-gray-900 py-3 px-4 bg-white">
                            <iframe
                                className="mb-1 rounded-2xl w-full"
                                src={convertToEmbedURL(message.message.videoLink!)}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                            <div className="text-gray-900 overflow-wrap-anywhere">
                                <ReactMarkdown components={components}>
                                    {message.message.message}
                                </ReactMarkdown>
                            </div>
                        </div>
                        <div className="text-gray-500 ml-2 mt-1 text-[12px]"
                             suppressHydrationWarning>
                            {calcTimeDiff(message.time)}
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return <BotTextMessage index={index} message={message}/>
    }
}
